import { BIModel } from './BIModel';

export class ProductRepublishBIModel extends BIModel {

    static eventName = 'product_republish';
    #actionType;

    constructor( actionType ) {
        super( ProductRepublishBIModel.eventName );
        this.#actionType = actionType;
    }

    static createFromDomainEvent( productRepublishEvent ) {
        return new ProductRepublishBIModel(
            productRepublishEvent.actionType
        );
    }

    get actionType() {
        return this.#actionType;
    }

    get modelData() {
        return {
            action_type: this.actionType
        };
    }

}